import s from './calendar-sync-modal.module.scss'
import { IconDownload } from '@tabler/icons-react';
import { Modal } from '@shared/ui/modal/modal';
import { Button } from '@shared/ui/button/button';
import { useProfile } from '@shared/api/useProfile';
import { useCalendarSyncModal } from '../../model/use-calendar-sync-modal';

export const CalendarSyncModal = () => {
	const { isOpen, close } = useCalendarSyncModal()
	const { data: profile } = useProfile()

	const feedUrl = `${process.env.REACT_APP_API_URL}/api/calendar/feed?token=${profile?.calendar_token}`

	return (
		<Modal
			{...{ isOpen, close }}
			title="Синхронизация с календарём"
			style={{
				content: {
					width: 'calc(100% - 40px)',
					maxWidth: '520px',
					maxHeight: 'calc(100svh - 40px)',
					overflow: 'auto',
				},
			}}
		>
			<br />
			<div className={s.card}>
				<p className={s.text}>
					Скачайте файл календаря и добавьте его в Google Календарь, Apple Календарь
					или другое приложение. Ваши занятия будут автоматически появляться в календаре.
				</p>
				{profile?.calendar_token ? (
					<Button
						label="Скачать файл календаря"
						lefticon={<IconDownload size={16} />}
						to={feedUrl}
						className={s.button}
						target={"_blank"}
					/>
				) : (
					<p className={s.text}>Файл календаря пока недоступен.</p>
				)}
				<div className={s.subTitle}>Как подключить</div>
				<ul className={s.instructions}>
					<li>
						<b>Google Календарь:</b> откройте Настройки → «Импорт и экспорт» → «Импорт» →
						выберите скачанный файл → «Импортировать».
					</li>
					<li>
						<b>Apple Календарь (iPhone/Mac):</b> откройте скачанный файл —
						система предложит добавить события в календарь.
					</li>
					<li>
						<b>Outlook:</b> Календарь → «Добавить календарь» → «Загрузить из файла» →
						выберите скачанный файл.
					</li>
				</ul>
			</div>
		</Modal>
	)
}
